(function () {
  if (window.location.search.includes("preview_theme_id=")) return;
  const p = window.location.pathname;
  const query = window.location.search || "";

  // Existiert die Query? Wenn ja, prüfen wir Parameter
  if (query) {
    const urlParams = new URLSearchParams(query);

    // Prüfen ob "page" == "1" ist UND "phcursor" existiert
    if (urlParams.get('page') === '1' && urlParams.has('phcursor')) {
      // Neue URL ohne Query-Parameter (Kanonische URL)
      const canonicalUrl = p;

      // Weiterleitung auf kanonische URL ohne Parameter
      window.location.replace(canonicalUrl);
      return; // Ausführung beenden, damit nicht weitere Weiterleitungen geprüft werden
    }
  }

  // Japan (FIS-31): jp.fissler.com is gone and only forwards to a 404, the distributor
  // runs fissler.co.jp. Old paths have no counterpart there, so /jp URLs go to its home
  // page and old recipes to its recipe overview, the same targets as the admin URL
  // redirects for the known paths; this catches the rest.
  if (p === "/jp" || p.startsWith("/jp/")) {
    const target = p.startsWith("/jp/journal/recipes") ? "blogs/recipes" : "";
    window.location.replace("https://fissler.co.jp/" + target + query);
    // The slash and page=1 clean-ups below call replace() again and the last call wins,
    // which would add a second 404 hop for /jp/…/ URLs.
    return;
  }

  // Global: global.fissler.com is this same store with the same URL redirects, so a /global
  // path that got here is unknown there too. Carrying it over sent global.fissler.com to
  // its own URL in an endless reload loop.
  if (p === "/global" || p.startsWith("/global/")) {
    window.location.replace("https://global.fissler.com/" + query);
    return;
  }

  // US: us.fissler.com is a separate store with its own /us/... redirects, so other hosts
  // hand the path over. On us.fissler.com itself the path is already unknown — keeping it
  // would reload the same URL forever.
  if (p === "/us" || p.startsWith("/us/")) {
    const keepPath = p !== "/us" && p !== "/us/" && window.location.hostname !== "us.fissler.com";
    window.location.replace("https://us.fissler.com" + (keepPath ? p : "/") + query);
    return;
  }

  // Shopify pagination redirect: Remove ?page=1 or &page=1 for any URL
  (function () {
    const url = new URL(window.location.href);
    // Find 'page' param and check if it's '1'
    if (url.searchParams.get("page") === "1") {
      url.searchParams.delete("page");
      // Remove trailing ? if no params left
      let newUrl = url.pathname + (url.search ? url.search : "");
      // Prevent redirect loop
      if (window.location.pathname + window.location.search !== newUrl) {
        window.location.replace(newUrl);
      }
    }
  })();

  (function () {
    const current = window.location.pathname;
    // Collapse all multiple slashes to single
    const normalized = current.replace(/\/{2,}/g, "/");
    // Remove trailing slash on all non-root paths
    const target =
      normalized === "/" ? normalized : normalized.replace(/\/$/, "");
    if (current !== target) {
      const query = window.location.search || "";
      const hash = window.location.hash || "";
      window.location.replace(target + query + hash);
    }
  })();
})();
